/*
 * Ryan O'Dowd
 * 2025-05-22
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors}) => {
  return {
    title: { // @TODO: renmae and abstract?
      color: colors.dialogText,
      fontSize: globalScale * 22, // @TODO: dynamic
      fontFamily: fonts.primaryBold,
      marginBottom: 32,
    },
    text: {
      display: 'inline',
      color: colors.dialogText,
    },
    link: {
      display: 'inline',
      color: colors.primary,
      fontFamily: fonts.secondaryBold,
      textDecorationLine: 'underline',
    },
    downloadLinksWrapper: {
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: 32,
    },
  };
};

export default getStyles;
